import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Hubspot from "../../Images/hubspot.png";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { styled } from "@mui/material/styles";
import example from "../../config/example.xlsx";
import { useLocation } from "react-router-dom";
import {
  createOneContact,
  deleteContactMember,
  getOneMemberList,
  updateContactMember,
  updateFileUpload,
} from "../../services/ContactList";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Menu from "@mui/material/Menu";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Loader from "../Loader";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const drawerWidth = 300;
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));
const Contact1 = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  const location = useLocation();

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const [pop1, setPop1] = useState(false);
  const handlePopOpen1 = () => setPop1(true);
  const handlePopClose1 = () => setPop1(false);

  const [pop2, setPop2] = useState(false);
  const handlePopOpen2 = () => setPop2(true);
  const handlePopClose2 = () => setPop2(false);
  const [editPop, setEditPop] = useState(false);

  const handleEditClosePop = () => setEditPop(false);

  const navigate = useNavigate();
  const [listId, setListId] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [addField, setAddField] = useState(false);
  const [fileError, setFileError] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [contacts, setContacts] = useState({
    firstName: "",
    lastName: "",
    email: "",
    number: "+91",
    listId: "",
    memberId: "",
  });
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    listId: "",
  });

  const [deleteId, setDeleteId] = useState(null);
  const [load, setLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleDownload = () => {
    const fileUrl = example; // Replace with the file URL
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "sample.xlsx"; // The file name you want to save as
    link.click();
  };

  useEffect(() => {
    const id = location?.state?.listId;
    setListId(id);
    setContacts({ ...contacts, listId: id });
    getMemberList(id);
    const intervalId = setInterval(() => {
      getMemberListLoad(id);
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const getMemberListLoad = async (id) => {
    const response = await getOneMemberList(id);
    if (response?.data?.success === true) {
      setMemberList(response.data.result);
    } 
  };

  const getMemberList = async (id) => {
    setIsLoading(true);
    const response = await getOneMemberList(id);
    if (response?.data?.success === true) {
      setMemberList(response.data.result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setFileName(event?.target?.files[0].name);
    setFileError("");
  };

  const handleEditOpenPop = (data) => {
    setEditPop(true);
    setContacts({
      ...contacts,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      number: data.customerNumber,
      memberId: data.memberId,
    });
  };

  const handleFileSubmit = async () => {
    if (!file) {
      //   toast.error("Please select a file to upload.");
      setFileError("Please select a file to upload");
      return;
    } else {
      const formData = new FormData();
      setLoad(true);
      formData.append("file", file);
      formData.append("listId", listId);
      const response = await updateFileUpload(formData);

      if (response?.data?.success === true) {
        toast.success(response.data.message);

        setPop(false);
        setFileName("");
        setFileError("");
        getMemberList(listId);
        setLoad(false);
        setFile(null);
      } else {
        toast.error(response?.data?.message);
        setFileError("");
        setLoad(false);

        // setPop(false)
      }
    }
  };
  //mewnu

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleDeleteChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (value === "+91" || /^[+]91[0-9]*$/.test(value)) {
      setContacts({ ...contacts, [name]: value, listId: listId });
    } else {
      setContacts({ ...contacts, [name]: value, listId: listId });
    }
  };
  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }
    if (fieldName === "number") {
      if (value === "" || value === undefined) {
        // errorMessage = "Phone Number is required";
        // isValid = false;
      } else if (/[^0-9+]/.test(fieldValue)) {
        errorMessage = "Only numbers are allowed";
        isValid = false;
      } else if (value?.length < 10) {
        errorMessage = "Must enter 10 numbers";
        isValid = false;
      }
    }
    if (fieldName === "firstName") {
      if (value === "" || value === undefined) {
        // errorMessage = "First Name is required";
        // isValid = false;
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const handleKeyPress = (event) => {
    // If the pressed key is not a number or a control key (e.g., backspace)
    if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
      event.preventDefault(); // Prevent the default action (typing)
    }
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!contacts.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(contacts.email)) {
      formErrors.email = "Email is invalid";
      isValid = false;
    }

    // Validate password
    if (!contacts.firstName) {
      formErrors.firstName = "First Name is required";
      isValid = false;
    }

    // Validate phone number
    if (!contacts.number) {
      formErrors.number = "Phone Number is required";
      isValid = false;
    } else if (/[^0-9+]/.test(contacts.number)) {
      formErrors.number = "Only numbers are allowed";
      isValid = false;
    } else if (contacts.number.length < 10) {
      formErrors.number = "please enter must 10 numbers";
      isValid = false;
    }

    setErrors(formErrors);

    return isValid;
  };

  const handleDeleteOpen = (id) => {
    setDeleteId(id);
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await createOneContact(contacts);

      if (response?.data?.success === true) {
        toast.success(response.data.message);
        handlePopClose2();
        getMemberList(listId);
        setContacts({
          firstName: "",
          lastName: "",
          email: "",
          listId: "",
          memberId: "",
          number: "+91",
        });
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };

  const handleDelete = async () => {
    const data = {
      listId: listId,
      memberId: deleteId,
    };
    setLoad(true);
    const response = await deleteContactMember(data);
    if (response?.data?.success === true) {
      toast.success(response.data.message);
      handleClose();
      getMemberList(listId);
      setLoad(false);
    } else {
      toast.error(response?.data?.message);
      setLoad(false);

      // setPop(false)
    }
  };

  const handleEditSumbit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const data={
        ...contacts,
        listId:listId
      }
      // if(contactList.name==="")
      // let formErrors = {};
      // let isValid = true;
      // if (contactList.name === "") {
      //   formErrors.name = "name is required";
      //   isValid = false;

      //   setErrors(formErrors);
      //   return isValid;
      // } else {
      const response = await updateContactMember(data);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setEditPop(false);
        // setContacts({});
        setContacts({
          firstName: "",
          lastName: "",
          email: "",
          listId: "",
          memberId: "",
          number: "+91",
        });
        setLoad(false);
        getMemberList(listId);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);

        // setPop(false)
      }
    } else {
      toast.error("please fill the all the fields");
    }
    // }
  };

  if(isLoading) return <Loader/>

  return (
    <div className="Contact1">
      <ToastContainer autoClose={2000} />
      {/* {isLoading===true &&  <Loader />} */}
     
      {memberList?.length > 0 ? (
        <div className="ContactListTable">
          {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
            <SideBar />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: isLgUp ? 5 : 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                marginTop: isLgUp ? "0px" : "80px",
              }}
            > */}
              <div className="graient-btn mt-30">
                <Button className="display-1" onClick={handlePopOpen2}>
                  Add new contact <AutoAwesomeIcon />
                </Button>
                <Modal
                  open={editPop}
                  onClose={handleEditClosePop}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box">
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        Edit Contact
                      </Typography>
                      {/* <div className="theme-borde-clr Add-Number-button">
                        <Button
                         
                          onClick={() => setAddField(!addField)}
                        >
                          Modify
                        </Button>
                      </div> */}
                    </Stack>
                    <div className="assistant-cnt">
                      <div className="input-common mt-20">
                        <label>Customer Number</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="+91- "
                          name="number"
                          value={contacts.number}
                          required
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.number}
                          helperText={errors.number}
                          onKeyPress={handleKeyPress}
                          inputProps={{ maxLength: 13 }} // Attach the key press handler
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>First Name</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="Enter first name value"
                          name="firstName"
                          value={contacts.firstName}
                          required
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.firstName}
                          helperText={errors.firstName}
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>Last Name</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter last name value"
                          name="lastName"
                          value={contacts.lastName}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>Email</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter email"
                          required
                          name="email"
                          value={contacts.email}
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.email}
                          helperText={errors.email}
                        />
                      </div>
                      {addField === true && (
                        <>
                          <div className="shadow-btn mt-30">
                            <Button>
                              Add New Field <AddIcon />
                            </Button>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20"
                          >
                            <div className="input-common mt-20">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                placeholder="Enter field name"
                              />
                            </div>
                            <div className="input-common mt-20">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                placeholder="Enter field name"
                              />
                            </div>
                          </Stack>
                        </>
                      )}
                    </div>

                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                      className="mt-20"
                    >
                      <div className="border-graient mt-10">
                        <Button
                          onClick={() => {
                            handleEditClosePop();
                            setAddField(false);
                            // setContacts({});
                            setContacts({
                              firstName: "",
                              lastName: "",
                              email: "",
                              listId: "",
                              memberId: "",
                              number: "+91",
                            });
                            setErrors({});
                          }}
                        >
                          Back
                        </Button>
                      </div>

                      <div className="border-graient mt-10">
                        {/* <Button
                          onClick={handleEditSumbit}
                          // onClick={() => {
                          //   navigate("/createassistant");
                          // }}
                        >
                          Update
                        </Button> */}
                        {load ? (
                          <Button>Processing...</Button>
                        ) : (
                          <Button
                            // onClick={() => {
                            //   navigate("/contact-list-table");
                            // }}
                            onClick={handleEditSumbit}
                          >
                            Update
                          </Button>
                        )}
                      </div>
                    </Stack>
                  </Box>
                </Modal>
                <Modal
                  open={pop2}
                  onClose={handlePopClose2}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box">
                    <div className="close-icons-popup">
                      <HighlightOffIcon onClick={handlePopClose2} />
                    </div>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        Create New Contact
                      </Typography>
                      {/* <div className="theme-borde-clr Add-Number-button">
                        <Button
                        
                          onClick={() => setAddField(!addField)}
                        >
                          Modify
                        </Button>
                      </div> */}
                    </Stack>
                    <div className="assistant-cnt">
                      <div className="input-common mt-20">
                        <label>Customer Number</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="+91- "
                          name="number"
                          value={contacts.number}
                          required
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.number}
                          helperText={errors.number}
                          onKeyPress={handleKeyPress}
                          inputProps={{ maxLength: 13 }} // Attach the key press handler
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>First Name</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="Enter first name value"
                          name="firstName"
                          value={contacts.firstName}
                          required
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.firstName}
                          helperText={errors.firstName}
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>Last Name</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter last name value"
                          name="lastName"
                          value={contacts.lastName}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="input-common mt-20">
                        <label>Email</label>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter email"
                          required
                          name="email"
                          value={contacts.email}
                          onChange={(e) => handleChange(e)}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.email}
                          helperText={errors.email}
                          // slotProps={{
                          //   input: {
                          //     endAdornment: (
                          //       <InputAdornment position="end">
                          //         {" "}
                          //         <IconButton edge="end">
                          //           <DeleteOutlineOutlinedIcon />
                          //         </IconButton>
                          //       </InputAdornment>
                          //     ),
                          //   },
                          // }}
                        />
                      </div>
                      {addField === true && (
                        <>
                          <div className="shadow-btn mt-30">
                            <Button>
                              Add New Field <AddIcon />
                            </Button>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20"
                          >
                            <div className="input-common mt-20">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                placeholder="Enter field name"
                              />
                            </div>
                            <div className="input-common mt-20">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                placeholder="Enter field name"
                              />
                            </div>
                          </Stack>
                        </>
                      )}
                    </div>

                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                      className="mt-20"
                    >
                      <div className="border-graient mt-10">
                        <Button
                          onClick={() => {
                            handlePopClose2();
                            setAddField(false);
                            // setContacts({});
                            setContacts({
                              firstName: "",
                              lastName: "",
                              email: "",
                              listId: "",
                              memberId: "",
                              number: "+91",
                            });
                            setErrors({});
                          }}
                        >
                          Back
                        </Button>
                      </div>

                      <div className="border-graient mt-10">
                        {/* <Button
                          onClick={handleSubmit}
                          // onClick={() => {
                          //   navigate("/createassistant");
                          // }}
                        >
                          Save
                        </Button> */}
                        {load ? (
                          <Button>Processing...</Button>
                        ) : (
                          <Button
                            // onClick={() => {
                            //   navigate("/contact-list-table");
                            // }}
                            onClick={handleSubmit}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </Stack>
                  </Box>
                </Modal>
                <Button
                  className="display-1"
                  onClick={handlePopOpen}
                  style={{ marginLeft: 10 }}
                >
                  Upload Contacts <AutoAwesomeIcon />
                </Button>
                <Modal
                  open={pop}
                  onClose={handlePopClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box">
                    <div className="close-icons-popup">
                      <HighlightOffIcon onClick={handlePopClose} />
                    </div>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      sx={{ textAlign: "center" }}
                    >
                      Upload Contacts
                    </Typography>
                    <Typography
                      id="modal-modal-title"
                      variant="p"
                      component="p"
                      sx={{ textAlign: "center", fontSize: "12px", mt: 2 }}
                    >
                      Additional extra excel columns are permited for move
                      variable but ensure you do not change the default header
                      values. Download the sample from here
                    </Typography>
                    <div className="border-graient mt-20 text-center border-graient-download-sample">
                      <Button
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={handleDownload}
                      >
                        Download Sample
                      </Button>
                    </div>
                    <div className="Contact1-Upload-File">
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ textAlign: "center" }}
                      >
                        Upload XLSX File
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        variant="p"
                        component="p"
                        sx={{
                          textAlign: "center",
                          fontSize: "12px",
                          mt: 1,
                        }}
                      >
                        Upload your file in same format as in above ample
                        file(Max Size 5 MB)
                      </Typography>
                      <div className="border-graient border-graient-upload mt-20 text-center mb-10">
                        {/* <TextField startIcon={<CloudUploadIcon />} type="file">Upload File</TextField> */}
                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                        >
                          {/* Upload files. */}
                          {fileName != "" ? fileName : "Upload files"}
                          <VisuallyHiddenInput
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // Only allow .xlsx files
                            onChange={(e) => handleFileChange(e)}
                            multiple
                          />
                        </Button>
                    
                      </div>
                      {fileError != "" && (
                          <span className="error" style={{ color: "red" }}>
                            {fileError}
                          </span>
                        )}
                    </div>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                      className="mt-20"
                    >
                      <div className="border-graient mt-10">
                        <Button
                          onClick={() => {
                            handlePopClose();
                            setFileName("");
                            setFileError("");
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                      <div className="border-graient mt-10">
                        {/* <Button onClick={handleFileSubmit}>Save</Button> */}
                        {load ? (
                          <Button>Processing...</Button>
                        ) : (
                          <Button
                            // onClick={() => {
                            //   navigate("/contact-list-table");
                            // }}
                            onClick={handleFileSubmit}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </Stack>
                  </Box>
                </Modal>
              </div>

              <Grid2 container spacing={2} style={{ marginTop: 10 }}>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mb-20"
                >
                  <div className="ContactListTable-main">
                    <TableContainer
                      component={Paper}
                      sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                    >
                      <Table
                        sx={{ minWidth: 700 }}
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">
                              CustomerNumber
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              First Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Last Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Email{" "}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Action
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {memberList?.length > 0 &&
                            memberList?.map((row, index) => (
                              <StyledTableRow key={row.name}>
                                <StyledTableCell component="th" scope="row">
                                  <div>
                                    <h4>{row.customerNumber}</h4>{" "}
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.firstName}</h4>
                                </StyledTableCell>
                                <StyledTableCell
                                  align="center"
                                  sx={{ maxWidth: "300px" }}
                                >
                                  <h4>{row.lastName}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.email}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {" "}
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ justifyContent: "center" }}
                                  >
                                     {/* <RemoveRedEyeIcon sx={{ cursor: "pointer" }}/> */}
                                    {" "}
                                    <CreateOutlinedIcon
                                      onClick={() => handleEditOpenPop(row)}
                                      sx={{ cursor: "pointer" }}
                                    />
                                    <DeleteOutlineOutlinedIcon
                                    sx={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        handleMenu(e);
                                        handleDeleteOpen(row.memberId);
                                      }}
                                    />
                                  </Stack>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                          <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                          >
                            <div className="Delete-button-popup ">
                              <div className="display-11 mt-10">
                                <Typography
                                  color="inherit"
                                  sx={{
                                    fontSize: "12px",
                                    textAlign: "start",
                                  }}
                                >
                                   <b style={{display:'flex',gap:'5px'}}>    <span className="red">
                                  <ErrorOutlineIcon />
                                </span>{" "}Delete this item</b>
                                  Are you sure to delete this item?
                                </Typography>
                              </div>
                              <Stack
                                direction="row"
                                spacing={2}
                                sx={{ justifyContent: "center" }}
                                className="assitant-stack"
                              >
                                <div className="border-graient Delete-button mt-10">
                                  <Button onClick={() => handleClose()}>
                                    NO
                                  </Button>
                                </div>
                                <div className="border-graient gradient-bg Delete-button mt-10">
                                  {/* <Button onClick={() => handleDelete()}>
                                    Yes
                                  </Button> */}
                                  {load ? (
                                    <Button>Processing...</Button>
                                  ) : (
                                    <Button
                                      // onClick={() => {
                                      //   navigate("/contact-list-table");
                                      // }}
                                      onClick={() => handleDelete()}
                                    >
                                      Yes
                                    </Button>
                                  )}
                                </div>
                              </Stack>
                            </div>
                          </Menu>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </Grid2>
              </Grid2>
            {/* </Box>
          </Box> */}
        </div>
      ) : (
        // <Box sx={{ display: isLgUp ? "flex" : "block" }}>
        //   <SideBar />

        //   <Box
        //     component="main"
        //     sx={{
        //       flexGrow: 1,
        //       p: isLgUp ? 5 : 1,
        //       width: { sm: `calc(100% - ${drawerWidth}px)` },
        //       marginTop: isLgUp ? "50px" : "80px",
        //     }}
        //   >
            <Grid2 container spacing={2}>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                className="mb-20"
              >
                <div className="create-assitant">
                  <h1>No Contact In this List</h1>
                  <p>You can either Upload or create manually</p>

                  <div className="modal-popup">
                    <div className="graient-btn mt-30">
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ justifyContent: "center" }}
                      >
                        <Button className="display-1" onClick={handlePopOpen}>
                          {" "}
                          <CloudUploadIcon /> Upload Contacts
                        </Button>
                        <Button className="display-1" onClick={handlePopOpen2}>
                          {" "}
                          {/* <AddIcon /> Import from CRM{" "} */}
                          <AddIcon /> Create Manually{" "}
                        </Button>
                      </Stack>
                      {/* <h4>OR</h4> */}
                    </div>
                    {/* <div className="border-graient2">
                    <Button className="display-1" onClick={handlePopOpen2}>
                      Create Manually
                    </Button>
                  </div> */}

                    {/* popup Upload Contacts */}
                    <Modal
                      open={pop}
                      onClose={handlePopClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="common-modal-box">
                        <div className="close-icons-popup">
                          <HighlightOffIcon onClick={handlePopClose} />
                        </div>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          sx={{ textAlign: "center" }}
                        >
                          Upload Contacts
                        </Typography>
                        <Typography
                          id="modal-modal-title"
                          variant="p"
                          component="p"
                          sx={{ textAlign: "center", fontSize: "12px", mt: 2 }}
                        >
                          Additional extra excel columns are permited for move
                          variable but ensure you do not change the default
                          header values. Download the sample from here
                        </Typography>
                        <div className="border-graient mt-20 text-center border-graient-download-sample">
                          <Button
                            startIcon={<FileDownloadOutlinedIcon />}
                            onClick={handleDownload}
                          >
                            Download Sample
                          </Button>
                        </div>
                        <div className="Contact1-Upload-File">
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ textAlign: "center" }}
                          >
                            Upload XLSX File
                          </Typography>
                          <Typography
                            id="modal-modal-title"
                            variant="p"
                            component="p"
                            sx={{
                              textAlign: "center",
                              fontSize: "12px",
                              mt: 1,
                            }}
                          >
                            Upload your file in same format as in above ample
                            file(Max Size 5 MB)
                          </Typography>
                          <div className="border-graient border-graient-upload mt-20 text-center mb-10">
                            {/* <TextField startIcon={<CloudUploadIcon />} type="file">Upload File</TextField> */}
                            <Button
                              component="label"
                              role={undefined}
                              variant="contained"
                              tabIndex={-1}
                              startIcon={<CloudUploadIcon />}
                            >
                              {/* Upload files. */}
                              {fileName != "" ? fileName : "Upload files"}
                              <VisuallyHiddenInput
                                type="file"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // Only allow .xlsx files
                                onChange={(e) => handleFileChange(e)}
                                multiple
                              />
                            </Button>
                          
                          </div>
                          {fileError != "" && (
                              <span className="error" style={{ color: "red" }}>
                                {fileError}
                              </span>
                            )}
                        </div>
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ justifyContent: "center" }}
                          className="mt-20"
                        >
                          <div className="border-graient mt-10">
                            <Button
                              onClick={() => {
                                handlePopClose();
                                setFileName("");
                                setFileError("");
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="border-graient mt-10">
                            {/* <Button onClick={handleFileSubmit}>Save</Button> */}
                            {load ? (
                              <Button>Processing...</Button>
                            ) : (
                              <Button
                                // onClick={() => {
                                //   navigate("/contact-list-table");
                                // }}
                                onClick={handleFileSubmit}
                              >
                                Save
                              </Button>
                            )}
                          </div>
                        </Stack>
                      </Box>
                    </Modal>

                    {/*popup Import from CRM */}
                    <Modal
                      open={pop1}
                      onClose={handlePopClose1}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="common-modal-box">
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                          className="mt-20 mb-20"
                        >
                          <div className="Hubspot-image">
                            {" "}
                            <img src={Hubspot} alt="Hubspot" />
                          </div>
                          <div className="border-graient Hubspot-button">
                            <Button
                              onClick={() => {
                                navigate("/contact-list-table");
                              }}
                              startIcon={<FileDownloadOutlinedIcon />}
                            >
                              Import From HubSpot
                            </Button>
                          </div>
                        </Stack>
                      </Box>
                    </Modal>

                    {/*popup Create Manually */}

                    <Modal
                      open={pop2}
                      onClose={handlePopClose2}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="common-modal-box">
                        <div className="close-icons-popup">
                          <HighlightOffIcon onClick={handlePopClose2} />
                        </div>
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            Create New Contact
                          </Typography>
                          {/* <div className="theme-borde-clr Add-Number-button">
                            <Button
                            
                              onClick={() => setAddField(!addField)}
                            >
                              Modify
                            </Button>
                          </div> */}
                        </Stack>
                        <div className="assistant-cnt">
                          <div className="input-common mt-20">
                            <label>Customer Number</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              placeholder="+91- "
                              name="number"
                              value={contacts.number}
                              required
                              onChange={(e) => handleChange(e)}
                              onFocus={(e) => validateFocus(e)}
                              onInput={validateFocus}
                              error={!!errors.number}
                              helperText={errors.number}
                              onKeyPress={handleKeyPress}
                              inputProps={{ maxLength: 13 }} // Attach the key press handler
                            />
                          </div>
                          <div className="input-common mt-20">
                            <label>First Name</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              placeholder="Enter first name value"
                              name="firstName"
                              value={contacts.firstName}
                              required
                              onChange={(e) => handleChange(e)}
                              onFocus={(e) => validateFocus(e)}
                              onInput={validateFocus}
                              error={!!errors.firstName}
                              helperText={errors.firstName}
                            />
                          </div>
                          <div className="input-common mt-20">
                            <label>Last Name</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              rows={4}
                              placeholder="Enter last name value"
                              name="lastName"
                              value={contacts.lastName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                          <div className="input-common mt-20">
                            <label>Email</label>
                            <TextField
                              fullWidth
                              id="fullWidth"
                              rows={4}
                              placeholder="Enter email"
                              required
                              name="email"
                              value={contacts.email}
                              onChange={(e) => handleChange(e)}
                              onFocus={(e) => validateFocus(e)}
                              onInput={validateFocus}
                              error={!!errors.email}
                              helperText={errors.email}
                              // slotProps={{
                              //   input: {
                              //     endAdornment: (
                              //       <InputAdornment position="end">
                              //         {" "}
                              //         <IconButton edge="end">
                              //           <DeleteOutlineOutlinedIcon />
                              //         </IconButton>
                              //       </InputAdornment>
                              //     ),
                              //   },
                              // }}
                            />
                          </div>
                          {addField === true && (
                            <>
                              <div className="shadow-btn mt-30">
                                <Button>
                                  Add New Field <AddIcon />
                                </Button>
                              </div>
                              <Stack
                                direction="row"
                                spacing={2}
                                sx={{ justifyContent: "center" }}
                                className="mt-20"
                              >
                                <div className="input-common mt-20">
                                  <TextField
                                    fullWidth
                                    id="fullWidth"
                                    rows={4}
                                    placeholder="Enter field name"
                                  />
                                </div>
                                <div className="input-common mt-20">
                                  <TextField
                                    fullWidth
                                    id="fullWidth"
                                    rows={4}
                                    placeholder="Enter field name"
                                  />
                                </div>
                              </Stack>
                            </>
                          )}
                        </div>

                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ justifyContent: "center" }}
                          className="mt-20"
                        >
                          <div className="border-graient mt-10">
                            <Button
                              onClick={() => {
                                handlePopClose2();
                                setAddField(false);
                                // setContacts({});
                                setContacts({
                                  firstName: "",
                                  lastName: "",
                                  email: "",
                                  listId: "",
                                  memberId: "",
                                  number: "+91",
                                });

                                setErrors({});
                              }}
                            >
                              Back
                            </Button>
                          </div>

                          <div className="border-graient mt-10">
                            {/* <Button
                              onClick={handleSubmit}
                              // onClick={() => {
                              //   navigate("/createassistant");
                              // }}
                            >
                              Save
                            </Button> */}
                            {load ? (
                              <Button>Processing...</Button>
                            ) : (
                              <Button
                                // onClick={() => {
                                //   navigate("/contact-list-table");
                                // }}
                                onClick={handleSubmit}
                              >
                                Save
                              </Button>
                            )}
                          </div>
                        </Stack>
                      </Box>
                    </Modal>
                  </div>
                </div>
              </Grid2>
            </Grid2>
        //   </Box>
        // </Box>
      )}
    </div>
  );
};

export default Contact1;
